import React from 'react';
import { gql, useFragment } from '@apollo/client';
import css from './wednesdayDetails.module.scss';
import '../../dishDetailsWithCustom.scss';

import boxCard1 from './img/boxCard1.w.jpg';
import boxCard2 from './img/boxCard2.w.jpg';

const WednesdayInfoP1 = () => (
    <div styleName="new-details-card-info wednesday">
        <div styleName="new-details-card-info-line wednesday">
            <div styleName="new-details-card-info-line-one">Лиловый сливочно-сырный крем</div>
            <div styleName="new-details-card-info-line-two basket-with--dots" />
            <div styleName="new-details-card-info-line-three">
                <span styleName="new-details-card-info-digit-value">450 </span>
                <span styleName="new-details-card-info-text">г</span>
            </div>
        </div>
        <div styleName="new-details-card-info-line wednesday">
            <div styleName="new-details-card-info-line-one">Пшеничная мука</div>
            <div styleName="new-details-card-info-line-two basket-with--dots" />
            <div styleName="new-details-card-info-line-three">
                <span styleName="new-details-card-info-digit-value">300 </span>
                <span styleName="new-details-card-info-text">г</span>
            </div>
        </div>
        <div styleName="new-details-card-info-line wednesday">
            <div styleName="new-details-card-info-line-one">Кофейный соус</div>
            <div styleName="new-details-card-info-line-two basket-with--dots" />
            <div styleName="new-details-card-info-line-three">
                <span styleName="new-details-card-info-digit-value">100 </span>
                <span styleName="new-details-card-info-text">г</span>
            </div>
        </div>
        <div styleName="new-details-card-info-line wednesday">
            <div styleName="new-details-card-info-line-one limited">Съедобные картинки для украшения</div>
            <div styleName="new-details-card-info-line-two basket-with--dots" />
            <div styleName="new-details-card-info-line-three">
                <span styleName="new-details-card-info-digit-value">12 </span>
                <span styleName="new-details-card-info-text">шт</span>
            </div>
        </div>
        <div styleName="new-details-card-info-line wednesday">
            <div styleName="new-details-card-info-line-one">Белый шоколад</div>
            <div styleName="new-details-card-info-line-two basket-with--dots" />
            <div styleName="new-details-card-info-line-three">
                <span styleName="new-details-card-info-digit-value">50 </span>
                <span styleName="new-details-card-info-text">г</span>
            </div>
        </div>
        <div styleName="new-details-card-info-line wednesday">
            <div styleName="new-details-card-info-line-one">Итальянское какао</div>
            <div styleName="new-details-card-info-line-two basket-with--dots" />
            <div styleName="new-details-card-info-line-three">
                <span styleName="new-details-card-info-digit-value">110 </span>
                <span styleName="new-details-card-info-text">г</span>
            </div>
        </div>
        <div styleName="new-details-card-info-line wednesday">
            <div styleName="new-details-card-info-line-one">Греческий йогурт</div>
            <div styleName="new-details-card-info-line-two basket-with--dots" />
            <div styleName="new-details-card-info-line-three">
                <span styleName="new-details-card-info-digit-value">130 </span>
                <span styleName="new-details-card-info-text">г</span>
            </div>
        </div>
        <div styleName="new-details-card-info-line wednesday">
            <div styleName="new-details-card-info-line-one">Сливочное масло</div>
            <div styleName="new-details-card-info-line-two basket-with--dots" />
            <div styleName="new-details-card-info-line-three">
                <span styleName="new-details-card-info-digit-value">100 </span>
                <span styleName="new-details-card-info-text">г</span>
            </div>
        </div>
        <div styleName="new-details-card-info-line wednesday">
            <div styleName="new-details-card-info-line-one">Яйца</div>
            <div styleName="new-details-card-info-line-two basket-with--dots" />
            <div styleName="new-details-card-info-line-three">
                <span styleName="new-details-card-info-digit-value">2 </span>
                <span styleName="new-details-card-info-text">шт</span>
            </div>
        </div>
        <div styleName="new-details-card-info-line wednesday">
            <div styleName="new-details-card-info-line-one">Сахар</div>
            <div styleName="new-details-card-info-line-two basket-with--dots" />
            <div styleName="new-details-card-info-line-three">
                <span styleName="new-details-card-info-digit-value">230 </span>
                <span styleName="new-details-card-info-text">г</span>
            </div>
        </div>
        <div styleName="new-details-card-info-line wednesday">
            <div styleName="new-details-card-info-line-one">Разрыхлитель</div>
            <div styleName="new-details-card-info-line-two basket-with--dots" />
            <div styleName="new-details-card-info-line-three">
                <span styleName="new-details-card-info-digit-value">4 </span>
                <span styleName="new-details-card-info-text">г</span>
            </div>
        </div>
        <div styleName="new-details-card-info-line wednesday">
            <div styleName="new-details-card-info-line-one">Сода</div>
            <div styleName="new-details-card-info-line-two basket-with--dots" />
            <div styleName="new-details-card-info-line-three">
                <span styleName="new-details-card-info-digit-value">3 </span>
                <span styleName="new-details-card-info-text">г</span>
            </div>
        </div>
        <div styleName="new-details-card-info-line wednesday">
            <div styleName="new-details-card-info-line-one">Формочки для выпечки</div>
            <div styleName="new-details-card-info-line-two basket-with--dots" />
            <div styleName="new-details-card-info-line-three">
                <span styleName="new-details-card-info-digit-value">12 </span>
                <span styleName="new-details-card-info-text">шт</span>
            </div>
        </div>
        <div styleName="new-details-card-info-line wednesday">
            <div styleName="new-details-card-info-line-one">Зубочистка</div>
            <div styleName="new-details-card-info-line-two basket-with--dots" />
            <div styleName="new-details-card-info-line-three">
                <span styleName="new-details-card-info-digit-value">1 </span>
                <span styleName="new-details-card-info-text">шт</span>
            </div>
        </div>

    </div>
);

const WednesdayInfoP2 = () => (
    <div styleName="new-details-card-info wednesday">
        <div styleName="new-details-card-info-line wednesday">
            <div styleName="new-details-card-info-line-one limited">Основа для чёрного лимонада с бамбуком</div>
            <div styleName="new-details-card-info-line-two basket-with--dots" />
            <div styleName="new-details-card-info-line-three">
                <span styleName="new-details-card-info-digit-value">500</span>
                <span styleName="new-details-card-info-text">г</span>
            </div>
        </div>
        <div styleName="new-details-card-info-line wednesday">
            <div styleName="new-details-card-info-line-one">Свежая мята</div>
            <div styleName="new-details-card-info-line-two basket-with--dots" />
            <div styleName="new-details-card-info-line-three">
                <span styleName="new-details-card-info-digit-value">10 </span>
                <span styleName="new-details-card-info-text">г</span>
            </div>
        </div>
        <div styleName="new-details-card-info-line wednesday">
            <div styleName="new-details-card-info-line-one">Свежий тимьян</div>
            <div styleName="new-details-card-info-line-two basket-with--dots" />
            <div styleName="new-details-card-info-line-three">
                <span styleName="new-details-card-info-digit-value">2 </span>
                <span styleName="new-details-card-info-text">г</span>
            </div>
        </div>
        <div styleName="new-details-card-info-line wednesday">
            <div styleName="new-details-card-info-line-one">Бумажные стаканчики</div>
            <div styleName="new-details-card-info-line-two basket-with--dots" />
            <div styleName="new-details-card-info-line-three">
                <span styleName="new-details-card-info-digit-value">6 </span>
                <span styleName="new-details-card-info-text">шт</span>
            </div>
        </div>
        <div styleName="new-details-card-info-line wednesday">
            <div styleName="new-details-card-info-line-one">Наклейки для стаканчиков</div>
            <div styleName="new-details-card-info-line-two basket-with--dots" />
            <div styleName="new-details-card-info-line-three">
                <span styleName="new-details-card-info-digit-value">6 </span>
                <span styleName="new-details-card-info-text">шт</span>
            </div>
        </div>
    </div>
);

const WednesdaySetDescription = () => (
    <div className={css.wednesdaySetList}>
        <div className={css.mainCard}>
            <div className={css.wednesdayDescription}>
                Красота своими руками! 12 капкейков со съедобными картинками и 1.5 литра чёрного лимонада в нарядных стаканчиках.
            </div>
            <img className={css.descriptionCardImageMobile} src={boxCard1} alt="description card" />
            <div className={`${css.cardContent} ${css.cardContentMobile}`}>
                <ul className={css.cardContentList}>
                    <li>
                        Готовить весело и просто даже с детьми:
                        всё уже отмерено, удобно
                        <br />
                        расфасовано — кухня останется чистой!
                    </li>
                    <li>
                        Лишняя посуда тоже не понадобится: формочки для капкейков и стаканчики
                        для лимонада с наклейками в стиле Уэнсдей — уже в наборе.
                    </li>
                    <li>
                        Используем натуральные красители: лимонад с бамбуковым углём, крем из
                        фиолетовой матчи и батата, картинки из сахарной бумаги со съедобными чернилами.
                    </li>
                </ul>
            </div>
        </div>
        <div className={css.mainCard}>
            <img className={css.descriptionCardImageMobile} src={boxCard2} alt="description card" />
        </div>
    </div>
);

export const WednesdayDetails = () => (
    <div className={css.wednesdayDetailsRoot}>
        <div className={css.wednesdayDishTitle}>
            Сладкая вечеринка
            <br />
            Уэнсдей
        </div>
        <div className={css.wednesdaySetList}>
            <WednesdaySetDescription />
        </div>
        <div className={css.wednesdaySetDescTitle}>
            Что в наборе
        </div>
        <div className={css.wednesdayTableTitle}>
            Для капкейков:
        </div>
        <WednesdayInfoP1 />
        <div className={css.wednesdayTableTitle}>
            Для лимонада:
        </div>
        <WednesdayInfoP2 />
    </div>
);
